import { render } from "./PoiForm.vue?vue&type=template&id=876d9c16"
import script from "./PoiForm.vue?vue&type=script&lang=js"
export * from "./PoiForm.vue?vue&type=script&lang=js"

import "./PoiForm.vue?vue&type=style&index=0&id=876d9c16&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__